import { SET_SELECTED_FACETS, RESET_FACET_FILTERS, SET_FACETS } from 'store/actions/facets'

const initialState = {
  loading: true,
  causes: [],
  regions: [],
  internationals: [],
  populations: [],
  supports: [],
  categories: [],
  headquarters: [],
  selected: []
}

const facetsReducer = (state = initialState, { type, payload = {} }) => {
  const { data } = payload

  switch (type) {
    case SET_SELECTED_FACETS:
      return {
        ...state,
        selected: data
      }
    case RESET_FACET_FILTERS:
      return {
        ...state,
        selected: []
      }
    case SET_FACETS:
      const { facets } = payload
      return {
        ...state,
        ...facets,
        loading: false
      }
    default:
      return state
  }
}

export default facetsReducer
